// extracted by mini-css-extract-plugin
module.exports = {"desc_table":"CompanyPolicy_desc_table__2GBiK","desc_table_col_1":"CompanyPolicy_desc_table_col_1__XVotf","desc_table_col_2":"CompanyPolicy_desc_table_col_2__3joRh"};